// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import { Badge, type BadgeProps } from '@mantine/core';
import type { JSX } from 'react';

export function TableBadge(props: BadgeProps): JSX.Element {
  return <Badge {...props} style={[{ minWidth: 'max-content', flexShrink: 0 }, props.style]} />;
}
